'use strict';
var defineProperty = require('../internals/object-define-property');

module.exports = function (target, name, descriptor) {
  return defineProperty.f(target, name, descriptor);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/define-built-in-accessor.js
// module id = 166
// module chunks = 13